import React from 'react'
import { Form, Input } from 'antd'
import { Box, IconButton, Paper, Typography } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import CloseIcon from '@mui/icons-material/Close'

import type { BlockPayload } from '../../../types'
import { UploadZone } from '../UploadZone'
import { IMAGE_MAX_SIZE } from '../utils'

interface Props {
  payload: { url?: string; alt?: string; caption?: string }
  onChange: (payload: BlockPayload) => void
}

export const ImageBlock: React.FC<Props> = ({ payload: p, onChange }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <UploadZone
        accept="image/*"
        color="#6EE7B7"
        icon={<CloudUploadIcon />}
        title="คลิกเพื่ออัพโหลด หรือลากไฟล์มาวางที่นี่"
        hint="PNG, JPG, WEBP, GIF — ไม่เกิน 10MB"
        maxSize={IMAGE_MAX_SIZE}
        onUpload={(url) =>
          onChange({
            url,
            alt: p?.alt ?? '',
            caption: p?.caption ?? '',
          })
        }
      />
      {p?.url && (
        <Paper variant="outlined" sx={{ p: 1.5, display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            component="img"
            src={p.url}
            alt="preview"
            sx={{ width: 48, height: 48, borderRadius: 1, objectFit: 'cover', bgcolor: 'action.hover' }}
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" noWrap>
              รูปภาพ
            </Typography>
            <Typography variant="caption" color="text.secondary">
              อัพโหลดแล้ว
            </Typography>
          </Box>
          <IconButton
            size="small"
            color="error"
            onClick={() =>
              onChange({
                url: '',
                alt: p?.alt ?? '',
                caption: p?.caption ?? '',
              })
            }
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Paper>
      )}
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Form.Item label="Alt Text" style={{ marginBottom: 0 }}>
          <Input
            placeholder="คำอธิบายรูป"
            value={p?.alt ?? ''}
            onChange={(e) =>
              onChange({
                url: p?.url ?? '',
                alt: e.target.value,
                caption: p?.caption ?? '',
              })
            }
          />
        </Form.Item>
        <Form.Item label="Caption" style={{ marginBottom: 0 }}>
          <Input
            placeholder="ข้อความใต้รูป"
            value={p?.caption ?? ''}
            onChange={(e) =>
              onChange({
                url: p?.url ?? '',
                alt: p?.alt ?? '',
                caption: e.target.value,
              })
            }
          />
        </Form.Item>
      </Box>
    </Box>
  )
}
